import Avatar from "./Avatar";
import Icon from "./icons/Icon";
import { fuehrende, rangliste } from "../spieler";
import "./PunktePille.css";

/**
 * Punktestand als EINE Pille: gestapelte Avatare + Fuehrender (Host) bzw.
 * eigener Platz (Mitspieler). Passt auch bei vielen Spielern, nichts wird
 * abgeschnitten — Antippen oeffnet die volle Tabelle.
 * eintraege: [{ name, score }], ich: eigener Name oder null, farbe(name) -> 1..8
 * @category spiel
 */
export function PunktePille({ eintraege, ich = null, farbe, onClick }) {
  const liste = rangliste(eintraege);
  const vorne = fuehrende(eintraege);
  const meiner = ich ? liste.find((e) => e.name === ich) : null;

  let text;
  if (meiner) {
    text = (
      <>
        {meiner.platz === 1 && meiner.score > 0 && <Icon name="krone" size={15} />}
        <b>Platz {meiner.platz}</b> <span className="wert">{meiner.score} Pkt.</span>
      </>
    );
  } else if (vorne.length === 1) {
    text = (
      <>
        <Icon name="krone" size={15} />
        <b>{vorne[0].name}</b> <span className="wert">{vorne[0].score}</span>
      </>
    );
  } else if (vorne.length > 1) {
    text = (
      <>
        <Icon name="krone" size={15} />
        <b>Gleichstand</b> <span className="wert">{vorne[0].score}</span>
      </>
    );
  } else {
    text = <b>0 Punkte</b>;
  }

  return (
    <button type="button" className="punkte-pille" onClick={onClick} aria-label="Punktestand anzeigen">
      <span className="stapel">
        {liste.slice(0, 4).map((e, i) => (
          <Avatar key={e.key ?? `${e.name}-${i}`} name={e.name} farbe={farbe(e.name)} groesse="klein" />
        ))}
        {liste.length > 4 && <span className="mehr">+{liste.length - 4}</span>}
      </span>
      <span className="zeile">{text}</span>
    </button>
  );
}

export default PunktePille;
